import React from 'react';
import type { OmdPanelSettings } from '../../../utils/omdPanelSettings';

type Row = { label: string; value: React.ReactNode };

export function OmdDetailGrid({
  rows,
  settings,
}: {
  rows: Row[];
  settings: OmdPanelSettings;
}) {
  const visible = rows.filter((r) => {
    if (settings.showEmptyFields) return true;
    const v = r.value;
    return v != null && v !== '' && v !== '-';
  });
  if (visible.length === 0) return null;

  return (
    <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-0">
      {visible.map((row) => (
        <div
          key={row.label}
          className="grid grid-cols-[minmax(0,7.5rem)_1fr] gap-2 py-1.5 border-b border-app-border last:border-0"
        >
          <dt className="text-xs font-medium text-app-text-subtle">{row.label}</dt>
          <dd className="text-sm text-app-text break-words">{row.value ?? '-'}</dd>
        </div>
      ))}
    </dl>
  );
}
